import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PhoneCall } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, unwrapObject } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/** How many leads were contacted today (the viewer's own, their team's, or everyone's, by role); opens that list */
export function ContactedChip() {
  const { hasPermission } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [count, setCount] = useState<number | null>(null);
  const allowed = hasPermission("lead.read");

  // Refresh every minute and on every page change, like the bell
  useEffect(() => {
    if (!allowed) return;
    const load = () =>
      api
        .get("/api/Lead/ContactedToday")
        .then((res) => setCount(unwrapObject<{ count: number }>(res).count ?? 0))
        .catch(() => undefined);
    void load();
    const timer = setInterval(load, 60000);
    return () => clearInterval(timer);
  }, [pathname, allowed]);

  if (!allowed || count === null) return null;
  return (
    <Button variant="outline" size="sm" className="h-8 gap-1.5 px-2.5" title="Leads contacted today" aria-label={`${count} leads contacted today`} onClick={() => navigate("/leads?tab=contacted_today")}>
      <PhoneCall className="size-3.5 text-success" />
      <span className="text-xs font-semibold tabular-nums">{count}</span>
      <span className="hidden text-xs text-muted-foreground @7xl/top:inline">contacted today</span>
    </Button>
  );
}
